import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { I18nLibModule } from 'portal-i18n-lib';
import { InfoTipLabelComponent } from './info-tip-label/info-tip-label.component';
import { InfoTipWrapperComponent } from './info-tip-wrapper/info-tip-wrapper.component';
import { InfoTip } from './info-tip.directive';

@NgModule(
	{ declarations:
		[ InfoTip
		, InfoTipWrapperComponent
		, InfoTipLabelComponent
		]
	, exports:
		[ InfoTip
		, InfoTipLabelComponent
		]
	,
	imports:
		[ MatTooltipModule
		, CommonModule
		, I18nLibModule
		]
	, id: 'dag-info-tip'
	}
)
export class InfoTipModule {
}
